export default __webpack_public_path__ + "static/media/ic_attendance_active.07c7ec69.svg";